import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { AuthenticationFacade } from '@planone/bau365/data-access-authentication';
import { map } from 'rxjs';

export const redirectToTickets = () => {
  const router = inject(Router);
  return inject(AuthenticationFacade).authenticated$.pipe(
    map((authenticated) => (authenticated ? router.parseUrl('/tickets') : true))
  );
};
